/**
 * Resync auto-respond policy — extracted pure so the critical gate is
 * unit-testable (review flag #1: a kicked member must NEVER receive new salts,
 * or removal-by-rotation is defeated).
 *
 * The rule: release salts only to a requester who is CURRENTLY a member.
 * "Currently a member" = their identity pubkey is known from a join payload
 * (memberIndex) or — legacy — appears in the board roster, AND is not on the
 * removal denylist. Anything else is ignored silently.
 */
export interface ResyncPolicyMembership {
  role: 'admin' | 'member';
  currentEpoch: number;
  removed?: string[];                     // identity pubkeys denied resync
  memberIndex?: Record<string, string>;   // pseudo pubkey -> identity pubkey
}

export function shouldRespondToResync(
  m: ResyncPolicyMembership | undefined,
  from: string,        // requester's IDENTITY pubkey (rumor author)
  haveEpoch: number,
  inRoster: boolean,   // legacy fallback: identity seen directly in roster
): boolean {
  if (!m || m.role !== 'admin') return false;          // only admins serve salts
  if (haveEpoch >= m.currentEpoch) return false;       // nothing to give
  if ((m.removed ?? []).includes(from)) return false;  // kicked members: never
  const known = Object.values(m.memberIndex ?? {});
  if (!known.includes(from) && !inRoster) return false; // strangers: never
  return true;
}
